module.exports = __webpack_public_path__ + "img/sign-up-email.29153a71.svg";